import styled from 'styled-components';

import { InfoBanner } from 'ui/banner';
import { spacing } from 'ui/theme';

const StyledInfoBanner = styled(InfoBanner)`
  margin-top: ${spacing.base};
  margin-bottom: ${spacing.half};
`;

type DisableWorkflowWarningProps = {
  isBulk: boolean;
};

export const DisableWorkflowWarning = ({ isBulk }: DisableWorkflowWarningProps) => (
  <>
    <p>
      This will prevent new users from being added to the journey{isBulk && 's'} and remove existing
      users after they complete the step they&lsquo;re on (or within 2 days if they&lsquo;re in a
      long delay).
    </p>
    <StyledInfoBanner>
      To keep existing users moving through the journey{isBulk && 's'} while preventing new users
      from being added, disconnect the Start tile{isBulk && 's'} instead of turning off the journey
      {isBulk && 's'}.
    </StyledInfoBanner>
  </>
);
